import React from 'react';
import PropTypes from 'prop-types';
import { LogoWithText } from '@sm/webassets';
import { t } from '@sm/intl';
import { Container, Typography } from '@sm/wds-react';
import { sanitizeString } from '@sm/utils';
import HeroFormCTA from '~app/components/HeroFormCTA';
import COPY from '~app/pages/EnterpriseThankYouV2/copy';
import './enterprise-thank-you-footer.scss';

const EnterpriseThankYouFooter = props => {
  const { premium, standard } = props;
  const flagPremium = () => {
    return premium ? 'sm-enterprise-thank-you-footer__premium-flag' : '';
  };

  const heroFormCTAArgs = {
    className: 'sm-hero-form-cta__enterprise-thank-you',
    ctaFormEmail: t(COPY.SIGN_UP_FORM_CTA_EMAIL_ADDRESS),
    ctaFormEmailPlaceholder: t(COPY.SIGN_UP_FORM_CTA_EMAIL_ADDRESS),
    ctaFormNewsletterOptOut: '',
    ctaFormPassword: t(COPY.SIGN_UP_FORM_CTA_PASSWORD),
    ctaFormPasswordPlaceholder: t(COPY.SIGN_UP_FORM_CTA_PASSWORD),
    ctaFormPrivacyConsent: 'privacy consent',
    ctaFormSubmit: t(COPY.SIGN_UP_FORM_CTA_SUBMIT),
    disclaimer: t(COPY.SIGN_UP_DISCLAIMER),
    utSource: 'enterprise_thank_you',
    utSource2: 'rebrand_ep_form',
    showThirdPartySignUpActions: false,
    showDisclaimer: false,
  };

  const renderDisclamer = () => {
    return (
      <If condition={standard && !premium}>
        <Container className="sm-enterprise-thank-you-footer__disclaimer">
          <Typography
            align="center"
            component="div"
            variant="bodySm"
            color="dark-muted"
            className="sm-enterprise-thank-you-footer__disclaimer-typography"
            data-testid="footer__Disclamer"
            dangerouslySetInnerHTML={{ __html: `${sanitizeString(t(COPY.SIGN_UP_DISCLAIMER))}` }} // eslint-disable-line jam3/no-sanitizer-with-danger
          />
        </Container>
      </If>
    );
  };

  const renderFooter = () => {
    return (
      <Container data-testid="footer__Footer" className={`${flagPremium()} sm-enterprise-thank-you-footer__outline`}>
        <Container className="sm-enterprise-thank-you-footer__powered-by-container" flex flexJustify="center">
          <Typography
            component="div"
            align="center"
            color="light"
            className="sm-enterprise-thank-you-footer__powered-by-text"
          >
            {t(COPY.POWERED_BY_TEXT)}
          </Typography>
        </Container>
        <Container flex flexJustify="center" className="sm-enterprise-thank-you-footer__branding-logo-container">
          <LogoWithText className="sm-enterprise-thank-you-footer__branding-logo" color="alt" />
        </Container>
        <Container className="sm-enterprise-thank-you-footer__branding-text" flex flexJustify="center">
          <Typography className="sm-enterprise-thank-you-footer__branding-text-inner">
            {t(COPY.SIGN_UP_CALLOUT_SUB_HEADER)}
          </Typography>
        </Container>
        <If condition={standard && !premium}>
          <Container className="sm-enterprise-thank-you-footer__sign-up-container" flex flexJustify="center">
            <HeroFormCTA className="sm-enterprise-thank-you__sign-up" {...heroFormCTAArgs} />
          </Container>
        </If>
      </Container>
    );
  };

  return (
    <>
      {renderFooter()}
      {renderDisclamer()}
    </>
  );
};

EnterpriseThankYouFooter.propTypes = {
  premium: PropTypes.bool.isRequired,
  standard: PropTypes.bool.isRequired,
};

export default EnterpriseThankYouFooter;
